import React from 'react';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { DateField } from '@routes-plan/ui';
import { OfficeOption } from './inventoryApi';
import { FilterGrid } from './ui';
import { useT } from '../../../i18n';

export interface RangeFilter {
  startDate: string;
  endDate: string;
  officeId: number | '';
}

interface Props {
  offices: OfficeOption[];
  value: RangeFilter;
  onChange: (value: RangeFilter) => void;
  onSearch: () => void;
  loading?: boolean;
}

/** Filtro estándar de listados de inventario: rango de fechas y sede, en una fila. */
const DateRangeOfficeFilter: React.FC<Props> = ({ offices, value, onChange, onSearch, loading }) => {
  const t = useT();
  return (
    <FilterGrid>
      <DateField
        size="small"
        fullWidth
        label={t('inventory.filter.from')}
        value={value.startDate || null}
        max={value.endDate || undefined}
        onChange={(v) => onChange({ ...value, startDate: v ?? '' })}
      />
      <DateField
        size="small"
        fullWidth
        label={t('inventory.filter.to')}
        value={value.endDate || null}
        min={value.startDate || undefined}
        onChange={(v) => onChange({ ...value, endDate: v ?? '' })}
      />
      <TextField
        select
        size="small"
        fullWidth
        label={t('common.office')}
        value={value.officeId === '' ? '' : String(value.officeId)}
        onChange={(e) => onChange({ ...value, officeId: Number(e.target.value) || '' })}
        SelectProps={{ displayEmpty: true }}
        InputLabelProps={{ shrink: true }}
      >
        <MenuItem value="">{t('inventory.filter.allOffices')}</MenuItem>
        {offices.map((o) => (
          <MenuItem key={o.id} value={String(o.id)}>
            {o.name}
          </MenuItem>
        ))}
      </TextField>
      <Button variant="contained" startIcon={<SearchOutlinedIcon />} onClick={onSearch} disabled={loading} sx={{ minHeight: 40 }}>
        {t('inventory.filter.query')}
      </Button>
    </FilterGrid>
  );
};

export default DateRangeOfficeFilter;

export const filterParams = (f: RangeFilter) => ({
  ...(f.startDate ? { startDate: f.startDate } : {}),
  ...(f.endDate ? { endDate: f.endDate } : {}),
  ...(f.officeId ? { officeId: f.officeId } : {}),
});
